import { io, type Socket } from "socket.io-client";
import type {
  UserClientToServer,
  UserServerToClient,
  AdminClientToServer,
  AdminServerToClient,
  PublicClientToServer,
  PublicServerToClient,
} from "@dropl/shared";
import { NS } from "@dropl/shared";

export type UserSocket = Socket<UserServerToClient, UserClientToServer>;
export type AdminSocket = Socket<AdminServerToClient, AdminClientToServer>;
export type PublicSocket = Socket<PublicServerToClient, PublicClientToServer>;

interface Options {

  base?: string;
}

const ioOptions = {
  path: "/socket.io",
  withCredentials: true,
  transports: ["websocket"] as string[],
  autoConnect: true,
};

export function connectUser(opts: Options = {}): UserSocket {
  return io((opts.base ?? "") + NS.user, ioOptions) as unknown as UserSocket;
}

export function connectAdmin(opts: Options = {}): AdminSocket {
  return io((opts.base ?? "") + NS.admin, ioOptions) as unknown as AdminSocket;
}

export function connectPublic(opts: Options = {}): PublicSocket {
  return io((opts.base ?? "") + NS.public, ioOptions) as unknown as PublicSocket;
}

let sharedPublic: PublicSocket | null = null;

/** Socket `/public` unique de l'onglet, partagé par la veille maintenance et
 *  la présence live — une seule connexion WebSocket par onglet. */
export function getPublicSocket(): PublicSocket {
  if (!sharedPublic) sharedPublic = connectPublic();
  return sharedPublic;
}
